interface ErrorTextProps {
    error: string;
}

export const ErrorText: React.FC<ErrorTextProps> = ({error}) => {
    return error ? <p className="block text-base text-red-600 my-4 text-center">{error}</p> : null
}
